import styled from 'styled-components';

export const FieldHelper = styled.div`
  font-size: 10px;
  font-family: var(--set-page-base-font-family);
  line-height: 1.3;
  color: #666666;
`;
